const operatorUserMenus = [
  {
    icon: "analytics_icon",
    key: "unAnswered",
    name: "UnAnswered Report",
    url: "home/app/Unanswered_Report",
    description: "",
    productionReady: true,
  },
  {
    icon: "article",
    key: "answered",
    name: "Answered Report",
    url: "home/app/AnsweredReport",
    description: "",
    productionReady: true,
  },
  {
    icon: "article",
    key: "caller.Call.DataAnalysis",
    name: "Caller Call Data Analysis",
    url: "home/app/CallerCallDataAnalysis",
    description: "",
    productionReady: true,
  },
  {
    icon: "summarize",
    key: "queue.Performance.Daily",
    name: "Queue-Performance Daily Report",
    url: "home/app/configurations/report/queuePerformanceDailyReport",
    description: "",
    productionReady: true,
  },
  {
    icon: "article",
    key: "queue.Performance.Summary",
    name: "Queue-Performance-Summary Report",
    url: "home/app/configurations/report/queuePerformanceSummary",
    description: "",
    productionReady: true,
  },
  {
    icon: "calendar_view_week",
    key: "user.login.logout",
    name: "Agent-LogIn-LogOut",
    url: "home/app/configurations/user-login-logout",
    description: "",
    productionReady: true,
  },
  {
    icon: "calendar_view_week",
    key: "queue.Time.Interval",
    name: "Queue Time Interval",
    url: "home/app/QueueTimeInterval",
    description: "",
    productionReady: true,
  },
  {
    icon: "calendar_view_week",
    key: "customer.agent.performance.Daily",
    name: "Customer Agent Daily Performance",
    url: "home/app/customer-agent-daily-performance",
    description: "",
    productionReady: true,
  },
  {
    icon: "assignment",
    key: "customer.agent.performance.summary",
    name: "Customer Agent Performance Summary",
    url: "home/app/customer-agent-performance-summary",
    description: "",
    productionReady: true,
  },
];

export { operatorUserMenus };
